import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Add any form-specific initialization here
  }

  // Can be used for form validation before submission
  validate(event) {
    const form = event.target
    const emailField = form.querySelector("input[type='email']")
    const passwordField = form.querySelector("input[name*='current_password']")

    // Basic validation
    if (emailField && !this.isValidEmail(emailField.value)) {
      event.preventDefault()
      this.showError(emailField, "有効なメールアドレスを入力してください")
      return false
    }

    if (passwordField && passwordField.value.length === 0) {
      event.preventDefault()
      this.showError(passwordField, "パスワードを入力してください")
      return false
    }

    return true
  }

  isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return emailRegex.test(email)
  }

  showError(field, message) {
    // Remove any existing error
    const existingError = field.parentElement.querySelector(".error-message")
    if (existingError) {
      existingError.remove()
    }

    // Add error message
    const errorDiv = document.createElement("div")
    errorDiv.className = "mt-1 text-sm text-red-600 error-message"
    errorDiv.textContent = message
    field.parentElement.appendChild(errorDiv)

    // Add error styling to field
    field.classList.add("border-red-500")
    field.classList.remove("border-gray-300")

    // Remove error after field is corrected
    field.addEventListener("input", () => {
      field.classList.remove("border-red-500")
      field.classList.add("border-gray-300")
      errorDiv.remove()
    }, { once: true })
  }
}
